import { render, staticRenderFns } from "./DalPage.vue?vue&type=template&id=92b391b0&scoped=true&"
import script from "./DalPage.vue?vue&type=script&lang=js&"
export * from "./DalPage.vue?vue&type=script&lang=js&"
import style0 from "./DalPage.vue?vue&type=style&index=0&id=92b391b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b391b0",
  null
  
)

export default component.exports